export default __webpack_public_path__ + "static/media/salmon.69565326.jpg";